import React, { useEffect, useMemo } from 'react';
import { Flex } from 'antd';
import { Outlet } from 'react-router-dom';

import { RecommendationsControls } from '../components/RecommendationsControls';
import { RecommendationsProps } from '../service/recommendations.interface';
import { useFilters } from '../../../../shops/features/products/hooks/useFilters';
import {
    CommonFiltersProps,
    CommonTableProps,
} from '../../../../crm/interfaces/common.interface';
import { FETCH_DELAY } from '../../../../crm/utils/common';
import { useLazyReadRecommendationsQuery } from '../service/recommendations-ai.api';
import { RecommendationsTable } from '../components/RecommendationsTable';

export const RecommendationsContainer = () => {
    const { updateFilters, filters, get, source, loading } = useFilters<
        CommonFiltersProps,
        RecommendationsProps
    >(useLazyReadRecommendationsQuery, null);

    const tableProps = useMemo<
        CommonTableProps<RecommendationsProps, CommonFiltersProps>
    >(
        () => ({
            loading,
            source,
            filters,
            updateFilters,
        }),
        [loading, source, filters, updateFilters]
    );

    useEffect(() => {
        const timeout = setTimeout(() => {
            get({ filters: filters }, true);
        }, FETCH_DELAY);
        return () => clearTimeout(timeout);
    }, [filters, get]);

    return (
        <Flex gap={24} vertical align={'flex-start'}>
            <RecommendationsControls />
            <RecommendationsTable {...tableProps} />
            <Outlet />
        </Flex>
    );
};
